import { Layout, ProgressBar } from "../components/funnel";
import { BridgeHero } from "../components/bridge/BridgeHero";
import { ThreeThings } from "../components/bridge/ThreeThings";
import { Toolkit } from "../components/bridge/Toolkit";
import { PriceBox } from "../components/bridge/PriceBox";
import { Testimonials } from "../components/bridge/Testimonials";

export default function BridgePage() {
  return (
    <Layout chrome={false} footerVariant="compact">
      <ProgressBar label="YOUR SEAT IS RESERVED, BUT YOU'RE NOT DONE" step="STEP 2 OF 3" percent={66} />
      <BridgeHero />
      <ThreeThings />
      <Toolkit />
      <PriceBox />
      <Testimonials />
    </Layout>
  );
}
